import useApiQuery from '@hooks/useApiQuery';
import QueryKeys from '@src/constants/queryKeys';
import { DistinctValuesParams } from '@src/types/Archivist';

interface UseDistinctValuesProps {
  params: DistinctValuesParams;
  options?: {
    enabled?: boolean;
    queryKeys?: string[];
  };
}

export default function useDistinctValuesQuery({
  params,
  options,
}: UseDistinctValuesProps) {
  const formattedParams = {
    ...(params.query_field && { query_field: params.query_field }),
    ...(params.multi_field && { multi_field: params.multi_field }),
    ...(params.filters && { filters: params.filters }),
  };

  return useApiQuery({
    queryKey: options?.queryKeys || [QueryKeys.distinctValues],
    apiPath: `/distinct-values`,
    method: 'POST',
    body: formattedParams,
    enabled: options?.enabled,
    useArchivistAPI: true,
  });
}
